export default __webpack_public_path__ + "static/logo-da319dbe184135b863063b5faacf2941.png";